<template>
  <v-dialog v-model="isOpen" max-width="500" :persistent="isConfirming">
    <v-card>
      <v-card-title class="c-modal__header">{{ dialogTitle }}</v-card-title>
      <v-card-text class="text-grey-darken-4 text-body-2">
        <slot> {{ dialogConfirmationBody }}</slot>
      </v-card-text>

      <v-card-actions class="justify-end">
        <k-button :primary="!dangerMode" :color="dangerMode ? 'red' : ''" :loading="isConfirming" :disabled="isConfirming" @click="emitConfirmCallback">{{ $t(confirmLabel) }}</k-button>
        <k-button :disabled="isConfirming" @click="emitCancelCallback">{{ $t(cancelLabel) }}</k-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { ref } from "vue"

const props = withDefaults(
  defineProps<{
    dialogTitle: string
    dialogConfirmationBody?: string
    confirmCallback: () => Promise<void> | void
    cancelCallback?: () => void
    confirmLabel?: string
    cancelLabel?: string
    dangerMode?: boolean
  }>(),
  {
    confirmLabel: "global.proceed",
    cancelLabel: "global.cancel",
    dangerMode: false,
    dialogConfirmationBody: "",
    cancelCallback: undefined,
  },
)

const isOpen = defineModel<boolean>({ required: true, default: false })
const isConfirming = ref(false)

async function emitConfirmCallback() {
  if (isConfirming.value) {
    return
  }

  isConfirming.value = true
  try {
    await props.confirmCallback()
    isOpen.value = false
  } catch {
    // The callback is responsible for reporting the failure.
  } finally {
    isConfirming.value = false
  }
}
function emitCancelCallback() {
  props.cancelCallback?.()
  isOpen.value = false
}
</script>
